import React from 'react';
import { MapPin } from 'lucide-react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function VenueCard({ section, data, theme }) {
  const anim = section.animation || {};
  const { venueName, address, mapLink, note } = data;
  if (!venueName && !address) return null;

  const isDark = isColorDark(theme.bg);
  const cardBg = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.03)';
  const borderC = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)';

  const googleUrl = `https://maps.google.com/?q=${encodeURIComponent(address || venueName)}`;
  const appleUrl = `https://maps.apple.com/?q=${encodeURIComponent(address || venueName)}`;

  return (
    <section className="px-5 py-20" data-testid="venue-section">
      <div className="max-w-sm mx-auto text-center">
        <AnimatedSection preset={anim.section || 'fade-up'}>
          <p
            className="text-xs tracking-[0.3em] uppercase mb-8"
            style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}
          >
            How to Get There
          </p>
        </AnimatedSection>
        <AnimatedSection preset={anim.section || 'fade-up'} delay={0.1}>
          <div className="rounded-2xl p-6 mb-4" style={{ background: cardBg, border: `1px solid ${borderC}` }}>
            <MapPin className="w-6 h-6 mx-auto mb-3" style={{ color: theme.accent }} />
            <h3 className="font-medium text-sm mb-1" style={{ color: theme.textPrimary }}>{venueName}</h3>
            {address && <p className="text-xs" style={{ color: theme.textSecondary }}>{address}</p>}
            {note && <p className="text-xs mt-2" style={{ color: theme.textSecondary }}>{note}</p>}
          </div>
        </AnimatedSection>
        <AnimatedSection preset={anim.section || 'fade-up'} delay={0.2}>
          <div className="flex gap-3 justify-center">
            <a
              href={googleUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 rounded-full text-xs font-medium tracking-wider transition-all hover:scale-105"
              style={{ background: theme.accent, color: '#fff', fontFamily: theme.eyebrowFont }}
            >
              Google Maps
            </a>
            <a
              href={appleUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 rounded-full text-xs font-medium tracking-wider transition-all hover:scale-105"
              style={{ background: 'transparent', color: theme.textPrimary, border: `1px solid ${borderC}`, fontFamily: theme.eyebrowFont }}
            >
              Apple Maps
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}

function isColorDark(hex) {
  if (!hex) return false;
  const c = hex.replace('#', '');
  if (c.length < 6) return false;
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
}
